// ------------------------ utility ------------------------ /

getUserLanguage = function () {
    let userLang = navigator.language;
    userLang = userLang.slice(0, 2)

    return userLang
}

// ------------------------ form ------------------------ //

isEmailAddress = function (string) {
    const regexMatch = /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,4}$/

    return !!string.match(regexMatch)
}

isAlphaString = function (string) {
    const regexMatch = /^[a-zA-Z-]+$/

    return !!string.match(regexMatch)
}

isPhone = function (string) {
    const regexMatch = /^(\+\d{1,2}\s)?\(?[23456789]\d{2}\)?[\s.-]\d{3}[\s.-]\d{4}/

    return !!string.match(regexMatch)
}

keyCodeIgnore = function (event) {
    const key = event.keyCode

    return ((key === 13) || (key === 229) || (key > 36 && key < 41) // left, up, right, down
    )
}

upKeyCodePhone = function (event) {
    const key = event.keyCode

    return ((key >= 48 && key <= 57) || // Allow number line
        (key >= 96 && key <= 105) || // Allow number pad
        (key === 189) || // Allow -
        (event.shiftKey === true || key === 35 || key === 36) || // Allow Shift, Home, End
        (key === 8 || key === 9 || key === 13 || key === 46) || // Allow Backspace, Tab, Enter, Delete
        (key > 36 && key < 41) || // Allow left, up, right, down
        (// Allow Ctrl/Command + A,C,V,X,Z,R
            (event.ctrlKey === true || event.metaKey === true) && (key === 65 || key === 67 || key === 86 || key === 88 || key === 90 || key === 82)))
}

formatKeyCodePhone = function (event) {
    const key = event.keyCode

    return ((key >= 48 && key <= 57) || // Allow number line
        (key >= 96 && key <= 105) || // Allow number pad
        (key === 189) || // Allow -
        (key === 8 || key === 46) || // Allow Backspace, Delete
        (// Allow Ctrl/Command + V,X,Z
            (event.ctrlKey === true || event.metaKey === true) && (key === 86 || key === 88 || key === 90)))
}

formatToPhone = (event) => {
    let caretPosition = event.target.selectionStart
    let inputRawLength = event.target.value.length

    const input = event.target.value.replace(/\D/g, '').substring(0, 10)
    const first = input.substring(0, 3)
    const middle = input.substring(3, 6)
    const last = input.substring(6, 10)

    let inputCleanLength = input.length

    let value

    if ([8, 46].includes(event.keyCode) && inputRawLength === 3) {
        value = first
    } else if ([8, 46].includes(event.keyCode) && inputRawLength === 7) {
        value = first + '-' + middle
    } else {
        if (inputCleanLength === 3 || inputCleanLength === 6) {
            caretPosition += 1
        }

        if (inputCleanLength > 5) {
            value = first + '-' + middle + '-' + last
        } else if (inputCleanLength > 2) {
            value = first + '-' + middle
        } else {
            value = first
        }
    }

    if (inputRawLength === caretPosition && value.length > caretPosition) {
        caretPosition += 1
    }

    event.target.value = value

    event.target.setSelectionRange(caretPosition, caretPosition)
}

// ------------------------ tracking ------------------------ //

googleTriggerEvent = function (event, args) {
    window.dataLayer = window.dataLayer || []

    let vars = {
        'event': event
    }

    // Merge vars with args if args is an object
    if (args && typeof args === 'object') {
        vars = { ...vars, ...args }
    }

    window.dataLayer.push(vars)
}

setupEverflow = async function () {
    console.log('everflow - setup')

    const oid = getEverflowParameter('oid')

    let transaction_id = EF.getTransactionId(oid)

    if (transaction_id) {
        console.log('transaction found', transaction_id)
    } else {
        transaction_id = EF.click({
            offer_id: oid,
            affiliate_id: getEverflowParameter('affid'),
            sub1: getEverflowParameter('sub1'),
            sub2: getEverflowParameter('sub2'),
            sub3: getEverflowParameter('sub3'),
            sub4: getEverflowParameter('sub4'),
            sub5: getEverflowParameter('sub5'),
            uid: getEverflowParameter('uid'),
            source_id: getEverflowParameter('source_id'),
            transaction_id: getEverflowParameter('_ef_transaction_id'),
            parameters: {
                fbclid: getEverflowParameter('fbclid'),
                ttclid: getEverflowParameter('ttclid'),
                gclid: getEverflowParameter('gclid'),
            },
        })

        console.log('transaction create', transaction_id)
    }

    setTransactionId(transaction_id)

    return transaction_id
}

getEverflowParameter = function (key) {
    // Get value by URL parameter and if it doesn't exist look for cookie value
    let value = EF.urlParameter(key) || readCookie(key)

    // If value is not present use default values
    if (!value) {
        switch (key) {
            case 'oid':
                value = trackingConfig.default.oid ?? ''
                break
            case 'affid':
                value = trackingConfig.default.affid ?? ''
                break
            case 'source_id':
                value = trackingConfig.default.source_id ?? ''
                break
        }
    }

    // For selected keys add cookie
    if (value && ['oid', 'affid', 'sub3', 'sub4', 'sub5'].includes(key) === true) {
        setCookie(key, value, 86400)
    }

    return value
}

setTransactionId = function (transaction_id) {
    console.log(transaction_id)

    document.querySelectorAll('input[name="transaction_id"]').forEach((input) => {
        input.value = transaction_id
    })
}

// ------------------------ functionality ------------------------ //

returnButtonProcessing = function(text = 'Processing...') {
    return ''
        + '<svg class="inline-block animate-spin mr-3 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">'
            + '<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>'
            + '<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>'
        + '</svg>'
        + ' ' + text
}

resetLeadButton = function() {
    document.querySelectorAll('.lead-cta button[type="submit"]').forEach(button => {
        button.removeAttribute('disabled')
        button.innerHTML = button.dataset.originalText
    })
}

setLicenseNum = function(string = 'Missing license num') {
    document.querySelector('#license-num').textContent = string
}

setupLeadCta = function() {
    function isValidEmail(inputEmail) {
        if (isEmailAddress(inputEmail.value) === false) {
            // Mark as invalid
            toggleValid(inputEmail, false)

            return false
        } else {
            // Mark as valid
            toggleValid(inputEmail, true)

            return true
        }
    }

    function isValidPostalCode(inputPostalCode) {
        if (inputPostalCode.value.length !== 5 || inputPostalCode.value === '00000') {
            // Mark as invalid
            toggleValid(inputPostalCode, false)

            return false
        } else {
            // Mark as valid
            toggleValid(inputPostalCode, true)

            return true
        }
    }

    document.querySelectorAll('.lead-cta').forEach((formElement) => {
        const checkData = formElement.dataset.check

        switch (checkData) {
            case 'email':
                let inputEmail = formElement.querySelector('input[name="email_address"]')

                inputEmail.addEventListener('keyup', async (event) => {
                    if (keyCodeIgnore(event) === true) {
                        return
                    }

                    isValidEmail(inputEmail)
                })

                inputEmail.addEventListener('change', async () => {
                    isValidEmail(inputEmail)
                })
                break
            case 'postal_code':
                let inputPostalCode = formElement.querySelector('input[name="postal_code"]')

                inputPostalCode.addEventListener('keyup', async (event) => {
                    if (keyCodeIgnore(event) === true) {
                        return
                    }

                    isValidPostalCode(inputPostalCode)
                })

                inputPostalCode.addEventListener('change', async () => {
                    isValidPostalCode(inputPostalCode)
                })
                break
        }

        const button = formElement.querySelector('button[type="submit"]')

        // Store the original button text to revert later
        if (!button.hasAttribute('data-original-text')) {
            button.setAttribute('data-original-text', button.innerHTML)
        }

        formElement.addEventListener('submit', function (e) {
            e.preventDefault()

            let hasError = false

            switch (checkData) {
                case 'email':
                    let inputEmail = formElement.querySelector('input[name="email_address"]')

                    hasError = isValidEmail(inputEmail)
                    break
                case 'postal_code':
                    let inputPostalCode = formElement.querySelector('input[name="postal_code"]')

                    hasError = isValidPostalCode(inputPostalCode)
                    break
            }

            if (hasError === false) {
                // Mark as loading
                button.setAttribute('disabled', 'disabled')
                button.innerHTML = returnButtonProcessing()

                // Submit
                formElement.submit()
            }
        })
    })

    window.addEventListener('pageshow', resetLeadButton)
}

// ------------------------ design ------------------------ //

setupNavMenu = function () {
    document.querySelector('#nav-menu-bars').addEventListener('click', function () {
        document.querySelector('#nav-menu-bars').style.display = 'none'
        document.querySelector('#nav-menu-close').style.display = 'block'
        document.querySelector('#nav-menu').classList.add('open')
    })

    document.querySelector('#nav-menu-close').addEventListener('click', function () {
        document.querySelector('#nav-menu-bars').style.display = 'block'
        document.querySelector('#nav-menu-close').style.display = 'none'
        document.querySelector('#nav-menu').classList.remove('open')
    })
}

setupDisclosure = function() {
    const disclosureElements = document.querySelectorAll('[data-nature="disclosure"]')

    for (const selectedElement of disclosureElements) {
        selectedElement.addEventListener('click', function (e) {
            e.preventDefault()

            document.querySelector('#modalDisclosure').style.display = 'block'
        })
    }

    document.querySelector('#closeModalDisclosure').addEventListener('click', function (e) {
        document.querySelector('#modalDisclosure').style.display = 'none'
    })
}
